import React from 'react';

import api from '../../../../services';

import AutoComplete from 'material-ui/AutoComplete';

class PIClub extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clubs: [],
        };

        this.changeAutoComplete = this.changeAutoComplete.bind(this);
        this.chooseAutoComplete = this.chooseAutoComplete.bind(this);
    }

    changeAutoComplete(searchText) {
        this.props.changeField({
            field: 'piClubObject.name',
            value: searchText,
        });

        this.props.changeField({
            field: 'piClubObject._id',
            value: '',
        });

        this.setState({
            clubs: [],
        }, () => {
            if (searchText) {
                api.findPIClubs(searchText)
                    .then((response) => {
                        if (response.status === 200) {
                            const piClubs = response.data.data.map(piClub => ({
                                name: piClub.name,
                                piClub,
                            }));

                            if (!piClubs.length) {
                                this.setState({
                                    clubs: [],
                                });

                                this.props.changeField({
                                    field: 'piClubObject._id',
                                    value: '',
                                });
                            } else {
                                this.setState({
                                    clubs: piClubs,
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        console.error('Error AutoComplete PI clubs - PIClub component', error);
                        return null;
                    });
            } else {
                this.props.clearError('piClubObject');
            }
        });
    }

    chooseAutoComplete(updateProperties) {
        this.setState({
            clubs: [],
        });

        this.props.changeField({
            field: 'piClubObject',
            value: updateProperties.piClub,
        });
    }

    render() {
        const { clubs } = this.state;
        const { piClubObject, getError, confirmed, modifiedFields, underStyle } = this.props;

        return (
            <AutoComplete
                name='piClubObject'
                disabled={confirmed}
                dataSource={clubs}
                dataSourceConfig={{ text: 'name', value: 'piClub' }}
                floatingLabelText='P&I Club'
                searchText={piClubObject.name}
                onUpdateInput={this.changeAutoComplete}
                onNewRequest={this.chooseAutoComplete}
                filter={AutoComplete.noFilter}
                errorText={getError('piClubObject')}
                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                popoverProps={{
                    canAutoPosition: true,
                }}
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('piClubObject.name') ? underStyle : null}
            />
        );
    }
}

export default PIClub;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/PIClub.jsx